import { resolveHTTP } from '@/services/api'
// import { baseUrl } from '@/services/axios'

const Api = resolveHTTP('/system/users')

// Api.avatarUrl = (user) => {
//   return `${baseUrl}/system/users/${user.id}/media`
// }

export default Api



// WEBPACK FOOTER //
// ./src/services/api/sys-users.js